import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import {
    login as apiLogin,
    logout as apiLogout,
    getToken,
    getStoredOperator,
    clearAuth
} from "../services/api";


// ============================================================
// CONTEXT
// ============================================================

const AuthContext =
    createContext(null);


// ============================================================
// PROVIDER
// ============================================================

export function AuthProvider({
    children
}) {

    const [
        operator,
        setOperator
    ] = useState(
        getStoredOperator()
    );

    const [
        token,
        setTokenState
    ] = useState(
        getToken()
    );

    const [
        loading,
        setLoading
    ] = useState(true);


    // ========================================================
    // AUTENTICAÇÃO INICIAL
    // ========================================================

    useEffect(() => {

        const storedToken =
            getToken();

        const storedOperator =
            getStoredOperator();


        if (
            storedToken &&
            storedOperator
        ) {

            setTokenState(
                storedToken
            );

            setOperator(
                storedOperator
            );

        } else {

            clearAuth();

            setTokenState(
                null
            );

            setOperator(
                null
            );

        }


        setLoading(
            false
        );

    }, []);


    // ========================================================
    // LOGIN
    // ========================================================

    const login = async (
        email,
        password
    ) => {

        const data =
            await apiLogin(
                email,
                password
            );


        setTokenState(
            data.token
        );


        setOperator(
            data.operator
        );


        return data;

    };


    // ========================================================
    // LOGOUT
    // ========================================================

    const logout = async () => {

        await apiLogout();

        setTokenState(
            null
        );

        setOperator(
            null
        );

    };


    // ========================================================
    // ESCUTAR EXPIRAÇÃO DO TOKEN
    // ========================================================

    useEffect(() => {

        const handleLogout =
            () => {

                setTokenState(
                    null
                );

                setOperator(
                    null
                );

            };


        window.addEventListener(
            "auth:logout",
            handleLogout
        );


        return () => {

            window.removeEventListener(
                "auth:logout",
                handleLogout
            );

        };

    }, []);


    // ========================================================
    // CONTEXTO
    // ========================================================

    const value = {

        operator,

        token,

        loading,

        isAuthenticated:
            Boolean(
                token &&
                operator
            ),

        login,

        logout

    };


    // ========================================================
    // LOADING
    // ========================================================

    if (loading) {

        return (

            <div
                style={{
                    minHeight:
                        "100vh",

                    display:
                        "flex",

                    alignItems:
                        "center",

                    justifyContent:
                        "center",

                    fontFamily:
                        "Arial, sans-serif"
                }}
            >

                Carregando...

            </div>

        );

    }


    return (

        <AuthContext.Provider
            value={value}
        >

            {children}

        </AuthContext.Provider>

    );

}


// ============================================================
// HOOK
// ============================================================

export function useAuth() {

    return useContext(
        AuthContext
    );

}